<template>
  <div id="warranty_content">
    <van-nav-bar
      title="完工报告"
      left-text="返回"
      left-arrow
      @click-left="onClickLeft"
    />
    <van-form validate-first @failed="onFailed" style="margin-bottom: 20px" @submit="onSubmit">
      <div v-for="(item, index) in postForm.q_a_list" class="add-report-list">
        <van-field
          v-model="item.q"
          rows="1"
          autosize
          label="故障原因"
          type="textarea"
          placeholder="故障原因"
        />
        <van-field
          v-model="item.a"
          rows="3"
          autosize
          label="处理办法"
          type="textarea"
          placeholder="处理办法"
        />
        <van-field name="uploader" label="上传图片">
          <template #input>
            <van-uploader v-model="imageList[index]"
              :max-size="4096 * 1024"
              multiple
              :before-read="beforeRead"
              :after-read="(file, name) => { return onRead(file, name, index) }"
              :before-delete="(file, key) => { return deleteFile(file, key, index) } "
              @oversize="onOversize"/>
          </template>
        </van-field>
        <div class="del-area"  v-if="index > 0">
          <van-button style="width: 30%; cursor: pointer; border-radius: 7px; margin: 5px auto; height: 40px;" type="danger" @click="deleteItem(index)">删除</van-button>
        </div>
      </div>
      <div class="report-area">
        <!--<van-cell title="完工时间" :value="postForm.done_at" style="text-align: left;" @click="showRepairDoneTime = true" />
        <van-popup v-model="showRepairDoneTime" position="bottom">
          <van-datetime-picker
            type="datetime"
            title="完工时间"
            v-model="postForm.selected_date"
            @confirm="selectStartDate"
            @cancel="showRepairDoneTime = false"
          />
        </van-popup>-->
        <van-field
          v-model="postForm.remark"
          rows="3"
          autosize
          label="留言"
          type="textarea"
          placeholder="留言"
        />
      </div>
      <div style="margin: 16px;">
        <van-button class="add-btn" type="info" native-type="button" @click="addReport" >添加报告</van-button>
        <van-button class="add-btn" type="primary" native-type="submit">提交</van-button>
      </div>
    </van-form>
    <van-form style="margin-bottom: 20px;" v-for="(item, index) in reportList" :key="index">
      <van-field
        v-model="item.reason"
        rows="2"
        autosize
        label="报告状态"
        type="textarea"
        placeholder="报告状态"
        readonly
      />
      <van-form v-for="(value, key) in item.completed_reports" :key="key">
        <van-field
          v-model="value.man_remark"
          rows="3"
          autosize
          label="报告备注"
          type="textarea"
          placeholder="报告备注"
          readonly
        />
        <van-field
          name="报修图片"
          label="报修图片"
          readonly
        />
          <van-image
            v-for="(image, key) in value.images"
            v-bind:key="key"
            width="100"
            height="100"
            style="margin-left:10px"
            :src="image.uri"
          />
      </van-form>
    </van-form>
  </div>
</template>

<script>
import {Toast} from 'vant'
import {getImageOss, getOssToken, reports, createReport} from '../../api/order'
import OSS from 'ali-oss'

export default {
  name: 'WarrantyReport',
  props: {
    showContent: {
      type: Object,
      default: null
    },
    showId: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      postForm: {
        maintenance_id: 0,
        done_at: '',
        q_a_list: [{
          file_ids: [],
          a: '',
          q: ''
        }],
        selected_date: new Date()
      },
      showRepairDoneTime: false,
      showPicker: false,
      imageList: [],
      categories: {},
      cascaderValue: '',
      reportList: [],
    }
  },
  created () {
    this.initPostForm()
  },
  methods: {
    selectStartDate (val) {
      this.showRepairDoneTime = false;
      this.postForm.done_at = this.formatDate(val);
    },
    formatDate(date) {
      return  `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()} ${date.getHours()}:${date.getMinutes()}`;
    },
    uploadFile(event, index) {
      console.log('upload file...', event, index)
    },
    addReport() {
      this.postForm.q_a_list.push({
        file_ids: [],
        a: '',
        q: ''
      })
    },
    initPostForm () {
      if (this.$route.query.id) {
        this.postForm.maintenance_id = this.$route.query.id
        reports(this.postForm.maintenance_id).then((res) => {
          console.log('res...data', res.data.data)
          if (res.data.data) {
            this.reportList = res.data.data
            console.log('report_list....', this.reportList)
          }
        })
      }
    },
    onFailed (errorInfo) {
      console.log('failed', errorInfo)
    },
    onClickLeft () {
      this.$router.go(-1);
      //this.$router.push({path: '/warranty_detail', query: {annex_id: this.$route.query.annex_id}})
    },
    deleteItem(index) {
      this.postForm.q_a_list.splice(index, 1)
    },
    onOversize (file) {
      Toast('文件大小不能超过 4M')
    },
    beforeRead (file) {
      if (file.length > 1) {
        for (const i in file) {
          if (file[i].type !== 'image/jpeg' && file[i].type !== 'image/png' && file[i].type !== 'image/jpg') {
            Toast('请上传图片')
            return false
          }
        }
      } else {
        if (file.type !== 'image/jpeg' && file.type !== 'image/png' && file.type !== 'image/jpg') {
          Toast('请上传图片')
          return false
        }
      }
      return true
    },
    async onRead (file, name, index) {
      if (file.length > 1) {
        for (const i in file) {
          let type = ''
          let fileSuffix = ''
          if (file[i].file.type === 'image/jpeg') {
            type = '.jpeg'
            fileSuffix = 'jpeg'
          }
          if (file[i].file.type === 'image/png') {
            type = '.png'
            fileSuffix = 'png'
          }
          if (file[i].file.type === 'image/jpg') {
            type = '.jpg'
            fileSuffix = 'jpg'
          }
          await getOssToken({ file_suffix: fileSuffix }).then((res) => {
            if (res.data.data) {
              const ossData = res.data.data
              const client = new OSS({
                region: 'oss-' + ossData.region_id,
                accessKeySecret: ossData.access_secret,
                accessKeyId: ossData.access_id,
                stsToken: ossData.secret_token,
                bucket: ossData.bucket
              })
              client.put(ossData.file_name, file[index].file).then((result) => {
                if (result && result.url) {
                  if (this.postForm.q_a_list && this.postForm.q_a_list[index]) {

                  } else {
                    this.postForm.q_a_list[index] = {
                      file_ids: [],
                      q: '',
                      a: ''
                    }
                  }
                  this.postForm.q_a_list[index].file_ids.push(ossData.file_id)
                }
              })
            }
          })
        }
      } else {
        let type = ''
        let fileSuffix = ''
        if (file.file.type === 'image/jpeg') {
          type = '.jpeg'
          fileSuffix = 'jpeg'
        }
        if (file.file.type === 'image/png') {
          type = '.png'
          fileSuffix = 'png'
        }
        if (file.file.type === 'image/jpg') {
          type = '.jpg'
          fileSuffix = 'jpg'
        }
        this.uploadImg(file.file, type, index, fileSuffix)
      }
    },
    async uploadImg (file, type, index, fileSuffix) {
      await getOssToken({ file_suffix: fileSuffix }).then((res) => {
        if (res.data.data) {
          const ossData = res.data.data
          const client = new OSS({
            region: 'oss-' + ossData.region_id,
            accessKeySecret: ossData.access_secret,
            accessKeyId: ossData.access_id,
            stsToken: ossData.secret_token,
            bucket: ossData.bucket
          })
          client.put(ossData.file_name, file).then((result) => {
            if (result && result.url) {
              if (this.postForm.q_a_list && this.postForm.q_a_list[index]) {

              } else {
                this.postForm.q_a_list[index] = {
                  file_ids: [],
                  q: '',
                  a: ''
                }
              }
              console.log('postForm......', this.postForm)
              this.postForm.q_a_list[index].file_ids.push(ossData.file_id)
            }
          })
        }
      })
    },
    deleteFile (file, key, index) {
      console.log('delete file...', file, key, index)
      this.postForm.lis[index].img_urls.splice(key, 1)
      return true
    },
    onChange (picker, values) {
      console.log(picker, values)
    },
    onSubmit () {
      this.postForm.order_worker_id = this.$route.query.order_worker_id
      console.log("platform.....", this.postForm)
      const postData = {
        remark: this.postForm.remark,
        order_worker_id: this.postForm.order_worker_id,
        q_a_list: []
      }
      for (const i in this.postForm.q_a_list) {
        const value = this.postForm.q_a_list[i]
        value.file_ids = this.postForm.q_a_list[i].file_ids.join(',')
        postData.q_a_list.push(value)
      }
      console.log('post.....data...', postData)
      createReport(postData).then((res) => {
          if (res.data.code === 0) {
            Toast('提交成功')
            setTimeout(() => {
              this.$router.push({path: '/warranty_detail', query: {annex_id: this.$route.query.annex_id, id: this.$route.query.id, ma_item_id: this.$route.query.ma_item_id,order_worker_id: this.$route.query.order_worker_id, appo_task_id: this.$route.query.appo_task_id}})
            }, 1000)
          }
      })
    }
  }
}
</script>

<style scoped>
  .add-btn {
    border-radius: 6px;
    width: 100px;
  }
  .add-report-list, .report-area {
    width: 96%;
    margin: 10px auto;
    border-radius: 40px;
  }

  .del-area {
    background-color: #FFFFFF;
    width: 100%;
    height: 50px;
  }
</style>



// WEBPACK FOOTER //
// src/views/order/report.vue